import request from "@/utils/request";

//获取行政区划
export async function getXzqhList(data) {
  return request({
    url: "/parcel-cms/dict/get-list-administrative",
    method: "post",
    data:data
  });
}
// 获取行政区划（存在开发区）
export async function getXzqhListUpgrade(){
  return request({
    url:"/parcel-cms/dict/park-administrative",
    method:"post"
  })
}

// 获取行政区划-登录用户关联的
export async function getXzqhListLogin() {
  return request({
    url: "/parcel-cms/dict/getAdministrativeAreaWhereIn",
    method: "post",
  });
}

//获取字典通用方法
export async function dictionaries(name) {
  return request({
    url: "/admin/dict/type/" + name,
    method: "get",
  });
}

//根据文件targetId删除
export async function delFile(targetId) {
  return request({
    url: "/parcel-cms/parcelAttachment/delete/" + targetId,
    method: "POST",
  });
}

//通过
export async function getCode(data) {
  return request({
    url: "/parcel-cms/dict/getLabel",
    method: "POST",
    params: data,
  });
}

//根据行政区name查询行政区code
export async function getValue(data) {
  return request({
    url: "/parcel-cms/dict/getValue",
    method: "POST",
    params: data,
  });
}

//根据行政区划code查询下级行政区划地块数量
export async function divisionCode(data) {
  return request({
    url: "/parcel-cms/administrative-statistics/divisionCode",
    method: "get",
    params:data
  });
}

//获取用地类型
export async function getTypeList(data) {
  return request({
    url: "/parcel-cms/parcel/type-list",
    method: "get",
    params:data
  });
}

//根据code查询下级行政区划列表
export async function getCodeChildren(data) {
  return request({
    url: "/parcel-cms/dict/get-administrative-not-tree",
    method: "post",
    data:data
  });
}
//获取土地推介专场
export async function promotionFive() {
  return request({
    url: "/parcel-cms/special-promotion/new/five",
    method: "get"
  });
}
//获取往届土地推介专场
export async function promotionLogin(data) {
  return request({
    url: "/parcel-cms/special-promotion/new/page-not-login",
    method: "post",
    data:data
  });
}
// 新推介专场编辑
export async function newPromotionEdit(id) {
  return request({
    url: "/parcel-cms/special-promotion/new/info/" + id,
    method: "get",
  });
}


//行政区划图形
export async function getCountyShp(data) {
  return request({
    url: "/parcel-cms/dict/shp",
    method: "post",
    params:data
  });
}

// 推荐专场模板一查询
export async function getRecommendDkList(data){
  return request({
    url: "/parcel-cms/special-promotion/new/inner-parcel",
    method: "post",
    data:data
  });
}


//发送用地需求短信,获取是否发送验证的状态
export  async function requireCode(data){
  return request({
    url:"/parcel-cms/note/require-code",
    method:"post",
    params:data
  })
}

//获取图片验证码
export  async function getCodeImg(data){
  return request({
    url:"/parcel-cms/captcha/get-captcha",
    method:"post",
    data:data,
  })
}


//发送用地需求短信,滑动验证码
export  async function captchaCode(data){
  return request({
    url:"/parcel-cms/note/captcha-code",
    method:"post",
    data:data,
  })
}
